import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

export default ({ bookTable, perRow, isHilight, setBarcode }) => {
  return (
    <BookHolder>
      {bookTable.map((book, i) => {
        let left = -1 * String(Math.ceil((i + 1) / perRow)).length
        return (
          <Book
            className="border border-dark"
            key={i}
            width={100 / perRow}
            hilight={isHilight(book)}
            onClick={() => setBarcode(Object.values(book.seriesNo) && Object.values(book.seriesNo)[0])}
          >
            {i < perRow && <TabOfCards left={left}>{i + 1}</TabOfCards>}
            {!(i % perRow) && <NumberOfRow left={left}>{Math.ceil((i + 1) / perRow)}</NumberOfRow>}
            <span>{book.volume}</span>
            <br />
            <span style={{ color: 'darkblue' }}>
              {book.roundNo}-{Object.keys(book.seriesNo).join(',')}
            </span>
            <span
              style={{
                color: 'red',
                position: 'absolute',
                top: 0,
                right: '.3vw',
                fontSize: '2vw',
              }}
            >
              {Object.keys(book.seriesNo).length}
            </span>
          </Book>
        )
      })}
    </BookHolder>
  )
}
const BookHolder = styled.div`
  margin-top: 50px;
  display: flex;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
`
const Book = styled.div`
  position: relative;
  background-color: ${(props) => props.hilight && 'yellow'};
  flex: ${(props) => props.width}%;
  max-width: ${(props) => props.width}%;
  // border: 1px solid #7e7e7e;
  font-size: 1vw;
  border-radius: 5px;
  cursor: pointer;
`
const TabOfCards = styled.span`
  position: fixed;
  padding-left: ${(props) => -1 * props.left}vw;
  padding-right: ${(props) => -1 * props.left}vw;
  background-color: #f9f9f9;
  top: 0.25vw;
  font-size: 1.5vw;
  text-align: center;
  z-index: 4;
`
const NumberOfRow = styled.div`
  position: absolute;
  left: ${(props) => props.left}vw;
  font-size: 1.5vw;
  top: 0.5vw;
`
